import { createFocusTrap } from 'focus-trap';
import closeAllDrawers from './closeAllDrawers';

const state = {
  activeTrap: null,
};

const options = {
  escapeDeactivates: false,
};

const removeFocusTrap = () => {
  if (!state.activeTrap) return;

  const { activeTrap } = state;

  activeTrap.deactivate();
  state.activeTrap = null;
};

const addFocusTrap = (event) => {
  if (!event.detail) return;
  const target = document.querySelector(`#${event.detail}`);
  state.activeTrap = createFocusTrap(target, options);
  state.activeTrap.activate();
};

const manageDrawerFocus = () => {
  const element = document.documentElement;

  element.addEventListener('drawerOpen', (event) => {
    setTimeout(() => {
      addFocusTrap(event);
    }, 200);
  });

  element.addEventListener('drawerClose', (event) => {
    removeFocusTrap();
  });

  // Add custom ESC functionality
  document.addEventListener('keydown', (event) => {
    const pressed = event.key;

    if (pressed === 'Escape') {
      closeAllDrawers();
    }
  });
};

manageDrawerFocus();

export default manageDrawerFocus;
